// extracted by mini-css-extract-plugin
export default {"errors":"ErrorMessage_errors__lwJxO","fade-in":"ErrorMessage_fade-in__maj4d"};